import { Button, Divider, Paper } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Column from "../../../../atoms/Column";
import Columns from "../../../../atoms/Columns";
import Loading from "../../../../atoms/Loading";
import { useNavigate, useParams } from "react-router";
import { Props } from "../../../../pages/Crew/Arrival/Create/types";
import Detail from "../../../../organisms/Crew/Arrival/Detail";
import SucsessButton from "../../../../atoms/SucsessButton";
import { ReportDexie } from "../../../../../dexie/Report";

type ConfirmProps = Props & {
  isLoading: boolean;
  onUpdate(): Promise<void>;
  onBack(): void;
  reportId: number;
  previousReport: ReportDexie | undefined;
};

const Confirm = (props: ConfirmProps): React.ReactElement => {
  const navigate = useNavigate();
  const { reportId } = useParams<"reportId">();

  const onClickSave = () => {
    props.onUpdate();
  };

  const onClickBack = () => {
    props.onBack();
  };

  return (
    <React.Fragment>
      <Loading isLoading={props.isLoading} />

      <Paper sx={{ backgroundColor: "#27292E", borderRadius: "20px" }}>
        <Detail
          isPreview={false}
          form={props.form}
          pageTitle={"Update Arrival Report"}
          previousReport={props.previousReport}
          isSend={false}
        />
        <Divider textAlign="left"></Divider>

        <Box sx={{ p: 2 }}>
          <Columns>
            <Column>
              <SucsessButton
                ButtonName={"Save"}
                disabled={false}
                onClick={onClickSave}
              />
            </Column>

            <Column>
              <Button
                sx={{
                  mx: 2,
                  color: "#AAAAAA",
                  width: 150,
                  backgroundColor: "#555860",
                  textTransform: "none",
                }}
                variant="contained"
                disabled={false}
                onClick={() => {
                  navigate(`/arrival/update/${reportId}`, { state: props.form });
                }}
              >
                {`Back & Edit`}
              </Button>
            </Column>
            <Column>
              <Button
                sx={{
                  mx: 2,
                  width: 150,
                  color: "#AAAAAA",
                  backgroundColor: "#555860 ",
                  textTransform: "none",
                }}
                variant="contained"
                disabled={false}
                onClick={() => onClickBack()}
              >
                Cancel
              </Button>
            </Column>
          </Columns>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default Confirm;
